import { Reveal } from './Motion';
import { Motif } from './Ornaments';

const values = [
  ['CRAFT', 'Things made by hand still teach me a lot about design.'],
  ['CULTURE', 'The best visual references are often already around us.'],
  ['STORIES', 'Every brand has one. I like figuring out how to tell it.'],
  ['CURIOSITY', 'The occasional rabbit hole usually leads somewhere useful.'],
];

export const DesignerValues = () => <section className="values-section page-inset" data-testid="values-section" aria-labelledby="values-heading">
  <Reveal className="values-top"><div><span className="eyebrow chapter-label" data-testid="values-label">05 / A FEW CONSTANTS</span><h2 id="values-heading" data-testid="values-heading">THINGS I KEEP<br />COMING BACK TO.</h2></div></Reveal>
  <div className="values-layout">
    <Reveal className="values-visual"><img src="/images/photo-update/lamp-making.webp" width="2000" height="1333" alt="An artisan hand-painting a patterned lampshade" loading="lazy" data-testid="craft-photo" /></Reveal>
    <div className="values-grid">{values.map(([title, description], i) => <Reveal key={title} className="value-note" delay={i * 0.04} data-testid={`value-${title.toLowerCase()}`}>
      <span className="value-number">0{i + 1}</span><div><h3>{title}</h3><p>{description}</p></div>
    </Reveal>)}</div>
    <Motif className="values-motif" variant="red" />
  </div>
</section>;